import { Node } from 'reactflow'

export default [] as Node[]
